import React, { Component } from 'react';
import './content-left-top-title-skelton.css';

class ContentLeftTopSkelton extends Component {
    constructor(props,context) {
        super(props, context);



    }
    render() {

            return (

                <div class="row row_style">
                    <div class="col-md-12">
                        <div class="reportd_pic reportd_pic_style">
                            <div></div>
                        </div>
                        <div class="reportd_title">
				<span className="span_skelton">
                    Published

					<p className="p_font_size p_font_size_skelton">
                      2017
                    </p>
				</span>
                            <h1 className="report_skelton_h1"></h1>
                            <h1 className="report_skelton_button"></h1>
                        </div>

                    </div>

                </div>
            );

    }


}


export default ContentLeftTopSkelton;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left-top-title/content-left-top-title-skelton.js